import React from 'react';

/**
 * LoadingState - Estado de carregamento padronizado
 *
 * Props:
 * - message: Texto a exibir (default: "Carregando...")
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - fullScreen: Boolean para tela inteira (default: false)
 * - className: Classes CSS adicionais
 */
interface LoadingStateProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  className?: string;
}

const LoadingState = ({
  message = 'Carregando...',
  size = 'md',
  fullScreen = false,
  className = ''
}: LoadingStateProps) => {
  const sizeClasses: Record<'sm' | 'md' | 'lg', string> = {
    sm: 'loading-spinner--sm',
    md: '',
    lg: 'loading-spinner--lg'
  };

  const containerClass = fullScreen 
    ? 'loading-container loading-container--fullscreen' 
    : 'loading-container';

  return (
    <div className={`${containerClass} ${className}`.trim()}>
      <div className={`loading-spinner ${sizeClasses[size]}`.trim()} />
      {message && <p className="loading-text">{message}</p>}
    </div>
  );
};

export default LoadingState;
